export default "/_next/static/04c0879ffbb3e6623ef52afc5b4a08cc.png";